import React from 'react';
import Toggle from '../ui/Toggle';
import Select from '../ui/Select';
import { BuildSettings } from '../../types';
import { useAppStore } from '../../store/appStore';

const ARCH_OPTIONS   = ['arm64-v8a', 'armeabi-v7a', 'x86_64', 'Universal'];
const TARGET_OPTIONS = ['release', 'debug', 'staging'];

const SettingItem: React.FC<{ label: string; children: React.ReactNode }> = ({ label, children }) => (
  <div
    style={{
      flex: '1 1 160px',
      background: 'var(--surface2)',
      border: '1px solid var(--border)',
      borderRadius: 'var(--radius-md)',
      padding: 14,
    }}
  >
    <div
      style={{
        fontSize: '0.68rem', color: 'var(--text-muted)',
        fontWeight: 700, letterSpacing: '0.08em',
        textTransform: 'uppercase', marginBottom: 8,
      }}
    >
      {label}
    </div>
    {children}
  </div>
);

const BuildSettingsPanel: React.FC = () => {
  const { buildSettings, updateBuildSettings } = useAppStore();

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12, marginBottom: 20 }}>
      <SettingItem label="Minify JS">
        <Toggle
          checked={buildSettings.minify}
          onChange={(v) => updateBuildSettings({ minify: v })}
          label={buildSettings.minify ? 'On' : 'Off'}
        />
      </SettingItem>

      <SettingItem label="Debug Mode">
        <Toggle
          checked={buildSettings.debugMode}
          onChange={(v) => updateBuildSettings({ debugMode: v })}
          label={buildSettings.debugMode ? 'On' : 'Off'}
        />
      </SettingItem>

      <SettingItem label="Signing">
        <Toggle
          checked={buildSettings.signingEnabled}
          onChange={(v) => updateBuildSettings({ signingEnabled: v })}
          label={buildSettings.signingEnabled ? 'On' : 'Off'}
        />
      </SettingItem>

      <SettingItem label="Architecture">
        <Select
          options={ARCH_OPTIONS}
          value={buildSettings.arch}
          onChange={(e) => updateBuildSettings({ arch: e.target.value as BuildSettings['arch'] })}
        />
      </SettingItem>

      <SettingItem label="Build Target">
        <Select
          options={TARGET_OPTIONS}
          value={buildSettings.target}
          onChange={(e) => updateBuildSettings({ target: e.target.value as BuildSettings['target'] })}
        />
      </SettingItem>
    </div>
  );
};

export default BuildSettingsPanel;
